import {Navigate, NonIndexRouteObject} from "react-router"
import {
    fmsCreateStore,
    fmsOverviewStore,
    fmsPackageDetailStore,
    fmsPackageOverviewStore,
    fmsPicklistDetailStore,
    fmsPicklistOverviewStore,
    fmsShippingClientDetailStore,
    fmsShippingClientListStore,
    fmsShippingClientOptionsStore,
    fmsShippingConfigStore,
    navigationStore,
    pageQueryStore,
    validationStore
} from "../store";
import {fmsCustomerStore} from "../store/fms/FmsCustomerStore";
import {ErrorPage} from "../components/page";
import {FmsApp} from "../components/app/FmsApp";
import {
    DocumentTypeDto,
    ShipmentListSortByDto,
    ShipmentPackageListSortByDto,
    ShipmentPackageStatusDto,
    ShipmentProcessTypeDto,
    ShipmentTypeDto,
    SortTypeDto
} from "../api/fms";
import React from "react";

const fms:NonIndexRouteObject[] = [{
    path: `/fms`,
    element: <FmsApp mode={'overview'}/>,
    errorElement: <ErrorPage/>,
    loader: async ({request}) => {
        await fmsCustomerStore.init()
        const searchParams = new URL(request.url).searchParams
        pageQueryStore.updateSystem('fms', searchParams)

        fmsOverviewStore.lostOnly = searchParams.get("notLocatable") === "true"
        fmsOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
        fmsOverviewStore.size = parseInt(searchParams.get("size") || "") || 25

        fmsOverviewStore.sortBy = searchParams.get('sortBy') as ShipmentListSortByDto || undefined
        fmsOverviewStore.sortType = searchParams.get('sortType') as SortTypeDto || undefined
        fmsOverviewStore.q = searchParams.get('q') || undefined
        fmsOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
        fmsOverviewStore.toRelative = searchParams.get('toRelative') || undefined
        fmsOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
        fmsOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined
        fmsOverviewStore.customerId = searchParams.get('customerId') || undefined
        fmsOverviewStore.documentType = searchParams.getAll('documentType') as DocumentTypeDto[] || undefined
        fmsOverviewStore.shipmentType = searchParams.getAll('shipmentType') as ShipmentTypeDto[] || undefined
        fmsOverviewStore.process = searchParams.getAll('process') as ShipmentProcessTypeDto[] || undefined
        fmsOverviewStore.status = searchParams.getAll('status') as ShipmentPackageStatusDto[] || undefined

        fmsOverviewStore.load().finally()
        navigationStore.setActivePath(request)
        return null
    }
},
    {
        path: `/fms/packages`,
        element: <FmsApp mode={'overview'} tab={'packages'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            await fmsCustomerStore.init()
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('fms-packages', searchParams)
            fmsPackageOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            fmsPackageOverviewStore.size = parseInt(searchParams.get("size") || "") || 25

            fmsPackageOverviewStore.sortBy = searchParams.get('sortBy') as ShipmentPackageListSortByDto || undefined
            fmsPackageOverviewStore.sortType = searchParams.get('sortType') as SortTypeDto || undefined
            fmsPackageOverviewStore.q = searchParams.get('q') || undefined
            fmsPackageOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
            fmsPackageOverviewStore.toRelative = searchParams.get('toRelative') || undefined
            fmsPackageOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            fmsPackageOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined
            fmsPackageOverviewStore.customerId = searchParams.get('customerId') || undefined
            fmsPackageOverviewStore.status = searchParams.getAll('status') as ShipmentPackageStatusDto[] || undefined
            fmsPackageOverviewStore.shipmentType = searchParams.getAll('shipmentType') as ShipmentTypeDto[] || undefined
            fmsPackageOverviewStore.process = searchParams.getAll('process') as ShipmentProcessTypeDto[] || undefined
            fmsPackageOverviewStore.compartment = Number(searchParams.get('compartment')) || undefined

            fmsPackageOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/fms/packages/:id`,
        element: <FmsApp mode={'package-detail'}/>,
        errorElement: <Navigate to={`/fms/packages`} replace={true}/>,
        loader: async ({params, request}) => {
            const result = await fmsPackageDetailStore.load(params.id!!)

            if (!result) {
                throw Error
            }

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/fms/picklist`,
        element: <FmsApp mode={'overview'} tab={'picklist'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('fms-picklist', searchParams)

            fmsPicklistOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            fmsPicklistOverviewStore.size = parseInt(searchParams.get("size") || "") || 25
            fmsPicklistOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
            fmsPicklistOverviewStore.toRelative = searchParams.get('toRelative') || undefined
            fmsPicklistOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            fmsPicklistOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined
            fmsPicklistOverviewStore.scanStatus = searchParams.get('scanStatus') || undefined

            fmsPicklistOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/fms/picklist/:id`,
        element: <FmsApp mode={'picklist-detail'}/>,
        errorElement: <Navigate to={`/fms/picklist`} replace={true}/>,
        loader: async ({params, request}) => {
            const result = await fmsPicklistDetailStore.load(params.id!!)

            if (!result) {
                throw Error
            }

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/fms/create`,
        element: <FmsApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            fmsCreateStore.reset()
            await fmsCustomerStore.init()

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/fms/shippingclient`,
        element: <FmsApp mode={'shipping-client'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            const searchParams = new URL(request.url).searchParams

            fmsShippingClientListStore.page = parseInt(searchParams.get("page") || "") || 1
            fmsShippingClientListStore.size = parseInt(searchParams.get("size") || "") || 25

            await fmsShippingClientListStore.load()
            return null
        }
    },
    {
        path: `/fms/shippingclient/create`,
        element: <FmsApp mode={'create-shipping-client'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            return null
        }
    },
    {
        path: `/fms/shippingclient/:id`,
        element: <FmsApp mode={'detail-shipping-client'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({params, request}) => {
            const result = await fmsShippingClientDetailStore.load(params.id!!)

            if (!result) {
                throw Error
            }

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/fms/shippingconfig`,
        element: <FmsApp mode={'shipping-client-config'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            await Promise.all([
                fmsShippingClientOptionsStore.load(),
                fmsShippingConfigStore.load()
            ])

            return null
        }
    },
]

export {
    fms
}
